export default "__VITE_ASSET__DjJukNZv__"